/**
 * === BLAZE CHANGE ===
 * File added for Blaze geolocation/currency overlay ONLY.
 * Do not remove without checking with Blaze.
 *
 * Issue (mobile):
 * Blaze inline mode hides .os_cn_text_desk below 768px and expects
 * .blz_os_country_mob (same pattern as .blz_os_language_mob for FR).
 * The country/currency button is missing that mobile span, so the
 * button collapses to width 0 while language still shows "| FR".
 *
 * Fix: ensure #blz_os_country_btn has .blz_os_country_mob with the
 * current currency text. Theme UI is not modified.
 */
(function () {
  'use strict';

  var BTN_ID = 'blz_os_country_btn';
  var DESK_SELECTOR = '.os_cn_text_desk';
  var MOB_CLASS = 'blz_os_country_mob';
  var debounceTimer = null;

  function ensureMobileCurrencyLabel() {
    var btn = document.getElementById(BTN_ID);
    if (!btn) return;

    var desk = btn.querySelector(DESK_SELECTOR);
    var text = desk ? (desk.textContent || '').trim() : '';
    if (!text) return;

    var mob = btn.querySelector('.' + MOB_CLASS);
    if (!mob) {
      mob = document.createElement('span');
      mob.className = MOB_CLASS;
      // Place after desktop label (Blaze language button pattern)
      if (desk && desk.nextSibling) {
        btn.insertBefore(mob, desk.nextSibling);
      } else if (desk) {
        desk.insertAdjacentElement('afterend', mob);
      } else {
        btn.insertBefore(mob, btn.firstChild);
      }
    }

    if (mob.textContent !== text) {
      mob.textContent = text;
    }
  }

  function schedule() {
    if (debounceTimer) window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(ensureMobileCurrencyLabel, 100);
  }

  function start() {
    ensureMobileCurrencyLabel();

    if (!document.body) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        var node = m.target;
        if (
          (node && node.id === BTN_ID) ||
          (node && node.closest && node.closest('#' + BTN_ID)) ||
          (node && node.querySelector && node.querySelector('#' + BTN_ID))
        ) {
          schedule();
          return;
        }
        if (m.addedNodes && m.addedNodes.length) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var added = m.addedNodes[j];
            if (added.nodeType !== 1) continue;
            if (
              added.id === BTN_ID ||
              (added.querySelector && added.querySelector('#' + BTN_ID))
            ) {
              schedule();
              return;
            }
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
